"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookmarkButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_react_1 = require("@streem/ui-react");
const BookmarkButton = ({ addBookmark }) => {
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    const [bookmarkAdded, setBookmarkAdded] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (bookmarkAdded) {
            setTimeout(() => {
                setBookmarkAdded(false);
            }, 1000);
        }
    }, [bookmarkAdded]);
    const Message = () => {
        let text = 'Add Bookmark';
        if (bookmarkAdded) {
            text = 'Bookmark added!';
        }
        return (0, jsx_runtime_1.jsx)(BookmarkMessage, { text: text });
    };
    const BookmarkMessage = ({ text }) => {
        return ((0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ color: "dark", size: "small" }, { children: text })));
    };
    const handleClose = () => {
        setShowTooltip(false);
    };
    return ((0, jsx_runtime_1.jsx)(BookmarkButtonWrapper, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Sensor, Object.assign({ onClickOutside: () => {
                setShowTooltip(false);
            }, onEscape: () => {
                setShowTooltip(false);
            } }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Tooltip, Object.assign({ message: (0, jsx_runtime_1.jsx)(Message, {}), offsetValue: 0, showTooltip: showTooltip, distance: 20 }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.IconButton, { "data-testid": "add-bookmark-button", background: "transparent", fill: ui_react_1.Theme.colors.azure, hoverFill: ui_react_1.Theme.colors.azureTransparent, highlight: "transparent", label: "Bookmark", iconName: "AddBookmarkIcon", onClick: () => {
                        setBookmarkAdded(true);
                        addBookmark();
                    }, onMouseEnter: () => setShowTooltip(true), onMouseLeave: handleClose, onMouseOver: () => setShowTooltip(true) }) })) })) }));
};
exports.BookmarkButton = BookmarkButton;
const BookmarkButtonWrapper = ui_react_1.styled.div(({ theme }) => ({
    padding: '4px',
    marginLeft: '16px',
    backgroundColor: theme.colors.white,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    height: '48px',
}));
//# sourceMappingURL=bookmark_button.js.map